import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import DefaultExpanded from '@/components/images/DefaultExpanded'
import ExpandableIcon from '@/components/images/ExpandableIcon'
import FixedIndexIcon from '@/components/images/FixedIndexIcon'
import { APP_STORE_EXPANDED_BY_DEFAULT } from '@/constants/featureToggles'

import messages from './messages'

import './index.scss'

import FeatureToggle from '@/components/FeatureToggle'

export default class UserInterfaceLayout extends Component<any, any> {
  static displayName = 'UserInterfaceLayout'

  render() {
    return (
      <div className="userInterfaceLayout__container">
        <p className="userInterfaceLayout__header">
          <FormattedMessage {...messages.title} />
        </p>
        <div className="userInterfaceLayout__block_wrapper">
          <div className="userInterfaceLayout__blocks">
            <p className="userInterfaceLayout__message">
              <FormattedMessage {...messages.fixedWidthTitle} />
            </p>
            <div className="userInterfaceLayout__icon">
              <FixedIndexIcon />
            </div>
            <p className="userInterfaceLayout__sub_message">
              <FormattedMessage {...messages.fixedWidthDescription} />
            </p>
          </div>
          <div className="userInterfaceLayout__blocks">
            <p className="userInterfaceLayout__message">
              <FormattedMessage {...messages.expandableTitle} />
            </p>
            <div className="userInterfaceLayout__icon">
              <ExpandableIcon />
            </div>
            <p className="userInterfaceLayout__sub_message">
              <FormattedMessage {...messages.expandableDescription} />
            </p>
          </div>
          <FeatureToggle feature={APP_STORE_EXPANDED_BY_DEFAULT}>
            <div className="userInterfaceLayout__blocks">
              <p className="userInterfaceLayout__message">
                <FormattedMessage {...messages.defaultExpandedTitle} />
              </p>
              <div className="userInterfaceLayout__icon">
                <DefaultExpanded />
              </div>
              <p className="userInterfaceLayout__sub_message">
                <FormattedMessage {...messages.defaultExpandedDescription} />
              </p>
            </div>
          </FeatureToggle>
        </div>
      </div>
    )
  }
}
